import Model from "~/models/_Model";

export default class Course extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "courses";
  }

  relations() {
    return {
      // students: Student
    };
  }

  // Computed Attributes
  get display_course() {
    return this.COURSE.trim();
  }

  get display_course_description() {
    return `${this.COURSE.trim()}: ${this.DESCRIPTION_CLEAN}`;
  }

  get display_block_type() {
    switch (this.BLOCK_TYPE) {
      case "B":
        return "Block";
      case "C":
        return "Blockette";
      case "N":
        return "Standalone";
    }
    return "Unknown Course Block Type";
  }
}
